export class FilteredList {
  agent: any[] = [];
  user: any[] = [];
  company: any[] = [];
  userPhone: any[] = [];
  inboundPhone: any[] = [];
  queue: any[] = [];
  status: any[] = [];
}

export class FilteredInteractionsList {
  id: any[] = [];
  agent: any[] = [];
  type: any[] = [];
  group: any[] = [];
  manager: any[] = [];
  queue: any[] = [];
  disposition: any[] = [];
  dispositionType: any[] = [];
  audits: any[] = [];
  recording: any[] = [];
}

export class FilteredAuditsList {
  agent: any[] = [];
  group: any[] = [];
  manager: any[] = [];
  auditor: any[] = [];
  status: any[] = [];
  surveyFrom: any[] = [];
}
